import React from 'react';

function Icon(props) {
  return (
    <svg
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      fill="currentColor"
      {...props}
    >
      <path d="M34.574 5.547a1.5 1.5 0 1 0-2.148-2.094l-19 19.5a1.5 1.5 0 0 0 0 2.094l19 19.5a1.5 1.5 0 1 0 2.148-2.094L16.594 24z" />
    </svg>
  );
}

export default Icon;
